import {BrowserRouter} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import store, {persistor} from "./store";
import RouteManager from "./pages/RouteManager";
import AutoLogoutWrapper from "./utils/AutoLogoutWrapper";
function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ToastContainer
            position="top-right"
            autoClose={2000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
          />

          <RouteManager dataTestId="route-manager" />
          <AutoLogoutWrapper />
        </PersistGate>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
